import React, { useState } from 'react';
import ConsentCheckboxes from './ConsentCheckboxes';
import { screenMessage } from '../lib/screenMessage';

/** Blocking modal. mode="reconsent" (terms changed, user signed in) or
 *  mode="oauth-signup" (new Google/Apple user, account not created yet).
 *  onAccept(consent) must call the backend and resolve/throw. */
export default function ConsentModal({ open, mode = 'reconsent', onAccept, onCancel, effectiveDate }) {
  const [c, setC] = useState({ terms: false, privacy: false });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  if (!open) return null;
  const ok = c.terms && c.privacy;
  const submit = async () => {
    setBusy(true); setErr('');
    try { await onAccept(c); } catch { setErr(screenMessage(mode === 'oauth-signup' ? 'register' : 'login')); }
    finally { setBusy(false); }
  };
  return (
    <div role="dialog" aria-modal="true" data-testid="consent-modal"
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', color: '#111', borderRadius: 12, maxWidth: 460, width: '100%', padding: 24 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
          {mode === 'oauth-signup' ? 'One last step' : "We've updated our terms"}
        </h2>
        <p style={{ fontSize: 14, marginBottom: 16 }}>
          {mode === 'oauth-signup'
            ? 'To finish creating your account, please confirm:'
            : `We updated our Terms of Service and Privacy Policy${effectiveDate ? ` on ${effectiveDate}` : ''}. Please review and accept them to keep using the app.`}
        </p>
        <ConsentCheckboxes value={c} onChange={setC} updated={mode === 'reconsent'} />
        {err && <p style={{ color: '#b91c1c', fontSize: 13, marginTop: 8 }}>{err}</p>}
        <div style={{ display: 'flex', gap: 8, marginTop: 20, justifyContent: 'flex-end' }}>
          <button type="button" onClick={onCancel} data-testid="consent-cancel"
            style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#111' }}>
            {mode === 'oauth-signup' ? 'Cancel' : 'Sign out'}
          </button>
          <button type="button" disabled={!ok || busy} onClick={submit} data-testid="consent-accept"
            style={{ padding: '8px 14px', borderRadius: 8, border: 0, background: ok ? '#111827' : '#9ca3af', color: '#fff' }}>
            {mode === 'oauth-signup' ? 'Create account' : 'Accept and continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
